import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRouterService } from '../http/api.router';
import { BaseHttpService } from '../http/base.http.service';

@Injectable({
  providedIn: 'root',
})
export class AppsHttpService extends BaseHttpService {
  private baseURL = `apps`;
  private superAdminBaseURL = `superadmin/apps`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public getApps() {
    const url = this.routerService.mount(`${this.baseURL}`);
    return this.read(url);
  }

  public getAppsByClient(clientId: number) {
    const url = this.routerService.mount(`${this.baseURL}/by-client/${clientId}`);
    return this.read(url);
  }

  public searchApps(queryParams: Record<string, string>) {
    return this.list(this.routerService.mount(this.superAdminBaseURL), queryParams);
  }

  public getAppDetail(appId: number) {
    return this.read(this.routerService.mount(`${this.superAdminBaseURL}/${appId}`));
  }

  public createApp(body: unknown) {
    return this.create(body, this.routerService.mount(this.superAdminBaseURL));
  }

  public updateApp(appId: number, body: unknown) {
    return this.update(body, this.routerService.mount(`${this.superAdminBaseURL}/${appId}`));
  }

  public deactivateApp(appId: number) {
    return this.delete(this.routerService.mount(`${this.superAdminBaseURL}/${appId}`));
  }

  public reactivateApp(appId: number) {
    return this.update({}, this.routerService.mount(`${this.superAdminBaseURL}/${appId}/reactivate`));
  }
}
